import { useState, useEffect } from "react";

import "css/Home.css";

import { getWords } from "utils/wordUtils";
import { log } from "utils/logger";

import Game from "screens/Game";
import FinalScore from "components/FinalScore";
import FloatingWords from "components/FloatingWords";
import Signature from "components/Signature";

const HOME_SCREEN_WORDS = getWords(25);

export default function Home() {
  const [index, setIndex] = useState(0);
  const [hasAddedWord, setHasAddedWord] = useState(false);
  const [completelyStopAddingWords, setCompletelyStopAddingWords] = useState(
    false
  );

  const [floatingWords, setFloatingWords] = useState([]);
  const [clearFloatingWords, setClearFloatingWords] = useState(() => {});
  const [finalStats, setFinalStats] = useState(null);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [showGame, setShowGame] = useState(false);

  const [homeScreenWords, setHomeScreenWords] = useState([]);

  useEffect(() => {
    log("home_screen");
  }, []);

  useEffect(() => {
    if (hasAddedWord) {
      return;
    }
    setHomeScreenWords([...homeScreenWords, HOME_SCREEN_WORDS[index]]);
    setHasAddedWord(true);
  }, [hasAddedWord, index, homeScreenWords]);

  useEffect(() => {
    if (index >= HOME_SCREEN_WORDS.length - 1 || completelyStopAddingWords) {
      return;
    }
    const timeout = setTimeout(function () {
      if (completelyStopAddingWords) {
        return;
      }
      setIndex(index + 1);
      setHasAddedWord(false);
    }, Math.floor(Math.random() * 1000) + 600);
    return () => clearTimeout(timeout);
  }, [completelyStopAddingWords, index, homeScreenWords]);

  const hideHomeScreenContent = buttonClicked || showGame;

  return (
    <div className="container">
      <div className="homeContainer">
        {showGame ? (
          <FloatingWords words={floatingWords} setClear={setClearFloatingWords}>
            {finalStats != null ? (
              <FinalScore
                accuracy={finalStats?.accuracy}
                wordCount={finalStats?.count}
                onReset={() => {
                  clearFloatingWords?.();
                  setFloatingWords([]);
                  finalStats?.onReset();
                  setFinalStats(null);
                }}
              />
            ) : null}
          </FloatingWords>
        ) : null}
        <div className={hideHomeScreenContent ? "fadeOut" : ""}>
          <FloatingWords words={homeScreenWords} width="100vw" />
        </div>
        <div className="homeContentAndButtonContainer">
          <div
            className={
              (hideHomeScreenContent ? "fadeOut " : "") + "logoContainer"
            }
          >
            <div className="mainTitle">LONG</div>
            <div className="mainSubtitle">words per minute</div>
            {/* <img className="logo" src="lwpm.png" alt="Long words per minute" /> */}
          </div>
          <div
            className={buttonClicked ? "buttonClicked" : "mainButton"}
            onClick={() => {
              if (!buttonClicked) {
                setCompletelyStopAddingWords(true);
                setButtonClicked(true);
                setTimeout(() => setShowGame(true), 700);
                log("start_button_clicked");
              }
            }}
          >
            {showGame ? (
              <Game
                setFloatingWords={setFloatingWords}
                setFinalStats={setFinalStats}
              />
            ) : (
              "START"
            )}
          </div>
          <div
            className={
              (hideHomeScreenContent ? "fadeOut " : "") + "homeContentContainer"
            }
          >
            <div className="homeDescription">
              Like a normal typing test... except <b>harder</b>
            </div>
          </div>
        </div>
        <Signature />
      </div>
    </div>
  );
}
